/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { BaseTreeStructureApi } from './BaseTreeStructureApi';

export class CommonApi extends BaseTreeStructureApi {
  endPoint: string = '/api';

  public getIssuers(referrerCode: string) {
    return this._get(this.endPoint + '/o/common/issuers/' + referrerCode, {});
  }
}
